import { render, staticRenderFns } from "./ModelList.vue?vue&type=template&id=0f32da0b"
import script from "./ModelList.vue?vue&type=script&lang=js"
export * from "./ModelList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../4rahgit/GPS-Tracking-Client-Panel/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports